import styled from "styled-components"

export const AlignText = styled.div`
  text-align: ${props => (props.align ? props.align : "center")};
`
